import { type MiddlewareFunction } from 'react-router';
import { type AppView } from '../../types/app';
import { viewContext } from './context';

const createAppMiddleware = (view: AppView): MiddlewareFunction => {
  return async ({ context }) => {
    context.set(viewContext, view);
  };
};

export default createAppMiddleware;
